import {
	DELIVERY_METHOD_KIND,
	EXPRESS_COURIER_PROVIDER,
} from "@dransay/api/models";
import type { PriceComparisonDiscount } from "~/features/price-comparison/price-comparison-discounts";
import { minEnabledFreeFromCents } from "~/features/products/pharmacy-picker/map-vendor-to-picker-item";
import type { PharmacyPickerItem } from "~/features/products/pharmacy-picker/pharmacy-picker.types";
import type { ProductDetailsSelectVendorItem } from "~/features/products/product-details-vendor-select.utils";
import { createOfferCardDeliveryBadges } from "~/features/products/product-details-vendor-select.utils";

export const mapPdpVendorToPickerItem = ({
	vendor,
	locale,
	formatFreeFromLabel,
	discount,
}: {
	vendor: ProductDetailsSelectVendorItem;
	locale: string;
	formatFreeFromLabel: (amount: string) => string;
	discount?: PriceComparisonDiscount;
}): PharmacyPickerItem => {
	const freeFromCents = minEnabledFreeFromCents(vendor.deliveryMethodsData);
	const enabledExpressMethods = (vendor.deliveryMethodsData ?? []).filter(
		(method) =>
			method.kind === DELIVERY_METHOD_KIND.EXPRESS_COURIER && method.enabled,
	);
	const offersUberExpress = enabledExpressMethods.some(
		(method) => method.provider === EXPRESS_COURIER_PROVIDER.UBER_DIRECT,
	);
	const offersExpressCourier = enabledExpressMethods.length > 0;
	const requiresExpressZoneCheck = offersExpressCourier && !offersUberExpress;
	return {
		id: String(vendor.id),
		name: vendor.title,
		address: vendor.address,
		featured: vendor.featured ?? false,
		combinedPaymentEnabled: vendor.combinedPaymentEnabled ?? false,
		price: vendor.price,
		distanceMeters: vendor.distanceMeters,
		offersExpressCourier,
		offersUberExpress,
		requiresExpressZoneCheck,
		...(typeof freeFromCents === "number" ? { freeFromCents } : {}),
		deliveryBadges: createOfferCardDeliveryBadges({
			deliveryMethodsData: vendor.deliveryMethodsData,
			locale,
			formatFreeFromLabel,
		}),
		discount:
			discount?.visible && discount.nonDiscountedPrice > 0
				? {
						originalPrice: discount.nonDiscountedPrice,
						percentage: Math.abs(discount.discountPercentage),
					}
				: undefined,
	};
};
